import {
    Component,
    input,
    output,
    ChangeDetectionStrategy,
} from '@angular/core'
import { ButtonModule } from '@openng/optimus-ui/button'

@Component({
    selector: 'app-client-error-state',
    imports: [ButtonModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './client-error-state.component.html',
})
export class ClientErrorStateComponent {
    message = input('Something went wrong')
    retryLabel = input('Try Again')
    retry = output<void>()
}
